import { Box, Typography, FormControl, InputLabel, Select, MenuItem, IconButton, Tooltip } from '@mui/material';
import { BookmarkBorderOutlined } from '@mui/icons-material';
import type { SortBy } from '../contexts/SearchContext';

export const SEARCH_SORT_OPTIONS = [
  { value: 'relevance', label: 'Most Relevant' },
  { value: 'newest', label: 'Newest First' },
  { value: 'oldest', label: 'Oldest First' },
  { value: 'title_asc', label: 'Title (A-Z)' },
  { value: 'title_desc', label: 'Title (Z-A)' },
  { value: 'year_asc', label: 'Year (Ascending)' },
  { value: 'year_desc', label: 'Year (Descending)' },
  // Parity with the Catalog (My Objects) sort — GH#1193. Backend SortBy enum
  // already supports these (catalog_asc/desc, custom_asc/desc).
  { value: 'catalog_asc', label: 'Catalog # Ascending' },
  { value: 'catalog_desc', label: 'Catalog # Descending' },
  { value: 'custom_asc', label: 'Inventory # Ascending' },
  { value: 'custom_desc', label: 'Inventory # Descending' },
] as const;

interface SearchResultsToolbarProps {
  total: number;
  sortBy: SortBy;
  onSortChange: (sort: SortBy) => void;
  onSaveSearch?: () => void;
  isAuthenticated?: boolean;
}

export const SearchResultsToolbar = ({
  total,
  sortBy,
  onSortChange,
  onSaveSearch,
  isAuthenticated = false,
}: SearchResultsToolbarProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 2,
      px: { xs: 2, sm: 0 },
    }}
  >
    <Typography variant="body2" color="text.secondary">
      {total} results
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isAuthenticated && total > 0 && onSaveSearch && (
        <Tooltip title="Save this search">
          <IconButton onClick={onSaveSearch} size="small" aria-label="Save Search">
            <BookmarkBorderOutlined />
          </IconButton>
        </Tooltip>
      )}
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="sort-label">Sort</InputLabel>
        <Select
          labelId="sort-label"
          label="Sort"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value as SortBy)}
        >
          {SEARCH_SORT_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  </Box>
);
